import { Theme } from '@mui/material/styles'
export const getCardStyles = (theme: Theme) => ({
  card: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
  },
  subtitle: { fontSize: '12px' },
  title: {
    fontSize: '18px',
    fontWeight: 'bold',
  },
})

export const getCollapsibleStyles = (theme: Theme) => ({
  expandIcon: { marginLeft: 0 },

  title: {
    fontSize: '16px',
    fontWeight: 'bold',
    paddingLeft: theme.spacing(1.4),
  },

  subtitle: { fontSize: '14px' },
})
